@if (showBrandFilters() && !subList) {
	<section brand-filter>
		@for (brand of brands; track brand.id) {
			<button small ghost [selected]="brandFilter[brand.shortName]" (click)="toggleBrandFilter(brand.shortName)" [loader]="false">
				<icon [attr.brand]="brand.shortName" type="logo" />
				{{ brand.shortName }}
			</button>
		}
	</section>
}
@if ((!empty || headers.length > 0)) {
	<table class="listview-container" [class.has-row-status]="displayStatusColumn" [class.has-action-column]="hasActionColumn" [style.--columns]="maxColumns()">
		@if (!subList) {
			<tr class="header">
				@if (displayStatusColumn && headers.length > 0) {
					<header class="status-column" [sortColumn]="false"></header>
				}
				<ng-content select="header" />
			</tr>
		}
		<ng-container *ngTemplateOutlet="content" />
		@if (editColumnFilter) {
			<filter-selector (filterChanged)="updateFilter($event)" />
		}
	</table>
}
@if (!subList && empty && emptyLabel) {
	<div class="empty-list">{{ emptyLabel | translate }}</div>
}

<ng-template #content>
	<ng-content select="row, list-item, ng-container" />
</ng-template>
